import React, {Component} from "react";

import {HashRouter, Route, Switch} from "react-router-dom";
import {DBHelpers, routes} from "./vars/rd";
import NotFound from "./pages/error/not.found";
import AuthLogin from "./pages/auth/login";
import Main from "./pages/main";
import Preloader from "./pages/include/preloader";
import Popup from "./pages/include/popup";
import Splash from "./pages/splash";
import AuthBusiness from "./pages/auth/business";
import AuthLoginProcess from "./pages/auth/login.process";
import Modal from "./pages/include/modal";
import AuthLogout from "./pages/auth/logout";
import {targetWindow} from "./index";

export default class App extends Component {
    timeout;
    constructor(props) {
        super(props);

        this.rhymeduckHandler = this.rhymeduckEvent.bind(this);
    }

    /**
     *
     */
    componentDidMount() {
        this.timeout = window.setTimeout(() => {
            if(targetWindow !== null) {
                targetWindow.postMessage(JSON.stringify({ type: 'app.ready' }), "*");
            }
            this.timeoutClear();
        }, 500);

        window.addEventListener("rhymeduck_event", this.rhymeduckHandler);
    }

    /**
     *
     */
    componentWillUnmount() {
        this.timeoutClear();
        window.removeEventListener("rhymeduck_event", this.rhymeduckHandler);
        DBHelpers.closeDB();
    }

    timeoutClear() {
        if(this.timeout) window.clearTimeout(this.timeout);
        this.timeout = null;
    }

    /**
     * @param e
     */
    rhymeduckEvent(e) {
        console.log(e);
    }


    render() {
        return (
            <div className={'app'}>
                <Preloader />
                <Modal />
                <Popup />
                <HashRouter>
                    <Switch>
                        <Route exact path={routes.splash} component={Splash} />
                        <Route exact path={routes.login} component={AuthLogin} />
                        <Route exact path={routes.logout} component={AuthLogout} />
                        <Route path={routes.login_process} component={AuthLoginProcess} />
                        <Route path="/login.process" component={AuthLoginProcess} />
                        <Route exact path={routes.business} component={AuthBusiness} />
                        <Route path={routes.main} component={Main} />
                        <Route path={routes.not_found} component={NotFound} />
                    </Switch>
                </HashRouter>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/apps.jsx